import cn from 'classnames'
import { HeightFix } from 'components/Common/HeightFix'
import React, { PropsWithChildren, ReactNode, useEffect } from 'react'

import { CartNavBar, NavBarProps } from './CartNavBar'

export type CartLayoutProps = {
  title?: ReactNode
  backgroundColor?: string
  showBack?: boolean
  showNavBar?: boolean
  navBarProps?: Omit<NavBarProps, 'title' | 'showBack'>
  className?: string
}

export const CartLayout = ({
  title,
  showBack = true,
  showNavBar = true,
  navBarProps,
  className,
  children,
}: PropsWithChildren<CartLayoutProps>) => {
  // ensure this page is scrolled to the top on mount
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 0)
  }, [])

  return (
    <div className="bg-surface-ui-background text-foreground">
      <HeightFix />
      {showNavBar && (
        <>
          <CartNavBar title={title} showBack={showBack} {...navBarProps} />
          <div className="h-14 w-full" />
        </>
      )}
      <div
        className={cn(
          'mx-auto flex max-w-[500px] flex-col',
          {
            'h-[calc(100vh-56px)]': showNavBar,
            'h-screen': !showNavBar,
          },
          className,
        )}
      >
        <div className="flex-1 sm:border-l sm:border-r">
          <div className="flex h-full flex-col">{children}</div>
        </div>
      </div>
    </div>
  )
}
